//export const SERVER_URL = "http://192.168.0.106:3001"
//export const CLIENT_URL = "http://192.168.0.106:3000"

export const SERVER_URL = "https://api.lllo.online/server"
export const CLIENT_URL = "https://lllo.online"